<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card" style="width: 95vw; max-width: 1400px;">
            <header class="modal-card-head">
                <p class="modal-card-title">Andamento</p>
                <button class="delete" @click="bSeleziona('chiudi')"></button>
            </header>
            <section class="modal-card-body">
                
                <div class="field is-grouped is-grouped-multiline mb-4 is-justify-content-center" v-if="headers.length > 0">
                    <div class="control" v-for="(header, index) in headers" :key="index">
                        <label class="checkbox custom-legend-item mx-2 has-text-weight-medium" v-if="index > 0">
                            <input type="checkbox" v-model="visibility[index]" @change="updateChartView">
                            <span class="color-dot" :style="{ backgroundColor: getColor(index), opacity: visibility[index] ? 1 : 0.3 }"></span>
                            <span :class="{'has-text-grey-light': !visibility[index]}">{{ header }}</span>
                        </label>
                    </div>
                </div>

                <div id="chart_div" style="width: 100%; height: 500px;" v-if="chartLoaded"></div>
                <div v-else class="has-text-centered p-5">Caricamento grafico in corso...</div>
            </section>
            <footer class="modal-card-foot">
            </footer>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref, defineProps, defineEmits, nextTick } from "vue";
    import { loadScript } from '@/code/utilita';

    const chartLoaded = ref(false);
    const headers = ref([]);
    const visibility = ref({});
    
    let chartInstance;
    let dataTableInstance;

    const baseColors = [
        'transparent', 
        '#3366cc', '#dc3912', '#ff9900', '#109618', '#990099', 
        '#0099c6', '#dd4477', '#66aa00', '#b82e2e', '#316395', 
        '#994499', '#22aa99', '#aaaa11', '#6633cc', '#e67300', 
        '#8b0707', '#651067', '#329262', '#5574a6', '#3b3eac'
    ];

    const props = defineProps({
        datiGrafico: {
            type: Array
        }
    });
    const emit = defineEmits(['selezionato']);

    function bSeleziona(comando) {
        emit('selezionato', comando);
    }

    function getColor(index) {
        if (index >= baseColors.length) {
            return baseColors[3 + (index % (baseColors.length - 3))];
        }
        return baseColors[index];
    }

    onMounted(async () => {
        if (props.datiGrafico && props.datiGrafico.length > 0) {
            headers.value = props.datiGrafico[0];
            headers.value.forEach((_, index) => {
                if (index > 0) {
                    visibility.value[index] = true;
                }
            });
        }

        await loadScript('https://www.gstatic.com/charts/loader.js');
        window.google.charts.load('current', {packages: ['corechart']});
        window.google.charts.setOnLoadCallback(async () => {
            chartLoaded.value = true;
            await nextTick();
            drawChart();
        });
    });

    function drawChart() {
        dataTableInstance = window.google.visualization.arrayToDataTable(props.datiGrafico);
        chartInstance = new window.google.visualization.ComboChart(document.getElementById('chart_div'));
        updateChartView();
    }

    function updateChartView() {
        if (!chartInstance || !dataTableInstance) return;

        let view = new window.google.visualization.DataView(dataTableInstance);
        
        let columns = [0]; 
        let seriesConfig = {};
        let activeColors = [];
        let activeSeriesIndex = 0;

        const hasImporto = headers.value[1] && headers.value[1].toLowerCase().includes('importo');

        for (let i = 1; i < headers.value.length; i++) {
            if (visibility.value[i]) {
                columns.push(i);
                activeColors.push(getColor(i)); 
                
                if (hasImporto) {
                    // LOGICA PER ELENCO LEADS (Importi + Quantità)
                    if (i === 1) {
                        seriesConfig[activeSeriesIndex] = { type: 'bars', targetAxisIndex: 0 };
                    } else if (i === 2) {
                        seriesConfig[activeSeriesIndex] = { type: 'line', targetAxisIndex: 1, lineWidth: 4 };
                    } else {
                        seriesConfig[activeSeriesIndex] = { type: 'line', targetAxisIndex: 1, lineWidth: 2, lineDashStyle: [4, 4] };
                    }
                } else {
                    // LOGICA PER ELENCO LAVORI (Solo Quantità)
                    if (i === 1) {
                        // Totale Lavori (Linea continua spessa, asse primario)
                        seriesConfig[activeSeriesIndex] = { type: 'line', targetAxisIndex: 0, lineWidth: 4 };
                    } else {
                        // Tag (Linea tratteggiata, stesso asse primario)
                        seriesConfig[activeSeriesIndex] = { type: 'line', targetAxisIndex: 0, lineWidth: 2, lineDashStyle: [4, 4] };
                    }
                }
                
                activeSeriesIndex++;
            }
        }

        view.setColumns(columns);

        if (columns.length > 1) {
            
            // Configura dinamicamente gli assi Y in base alla presenza dell'importo
            let vAxesConfig = {};
            if (hasImporto) {
                vAxesConfig = {
                    0: { title: 'Importo (€)', format: 'short', textStyle: { color: getColor(1)} },
                    1: { title: 'Dettaglio (Q.tà)', format: '#', textStyle: { color: getColor(2)} }
                };
            } else {
                vAxesConfig = {
                    0: { title: 'Quantità', format: '#', textStyle: { color: getColor(1)} }
                };
            }

            var options = {
                chartArea: { width: '85%', height: '75%' },
                legend: 'none', 
                colors: activeColors,
                seriesType: 'line', 
                series: seriesConfig,
                vAxes: vAxesConfig,
                hAxis: { title: 'Mese' },
                animation: {
                    duration: 400,
                    easing: 'out'
                },
                focusTarget: 'category' 
            };

            chartInstance.draw(view, options);
        } else {
            chartInstance.clearChart();
        }
    }
</script>

<style scoped>
    .custom-legend-item {
        display: flex;
        align-items: center;
        cursor: pointer;
        user-select: none;
    }
    
    .custom-legend-item input[type="checkbox"] {
        margin-right: 6px;
    }

    .color-dot {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 6px;
        transition: opacity 0.2s ease-in-out;
    }
</style>